import vueI18n from '@/lang'
import { v4 as uuidv4 } from 'uuid';

// 国际化
const { global: { t }} = vueI18n

function getMonthEnglish (M, isFullName = false) {
	let str
	switch (M) {
		case '01-':
			str = isFullName ? t('january') : t('jan')
			break
		case '02-':
			str = isFullName ? t('february') : t('feb')
			break
		case '03-':
			str = isFullName ? t('march') : t('mar')
			break
		case '04-':
			str = isFullName ? t('april') : t('apr')
			break
		case '05-':
			str = t('may')
			break
		case '06-':
			str = isFullName ? t('june') : t('jun')
			break
		case '07-':
			str = isFullName ? t('july') : t('jul')
			break
		case '08-':
			str = isFullName ? t('august') : t('aug')
			break
		case '09-':
			str = isFullName ? t('september') : t('sep')
			break
		case '10-':
			str = isFullName ? t('october') : t('oct')
			break
		case '11-':
			str = isFullName ? t('november') : t('nov')
			break
		case '12-':
			str = isFullName ? t('december') : t('dec')
			break
	}
	return str
}

export default {
  // 票数格式化
  formatVote: (val) => {
    const isChina = import.meta.env.VITE_COUNTRY === 'CHINA'
    const formatValue = val.toString()
    let formatNum = Array.from(formatValue).reverse().reduce((prev, next, index) => {
      prev.unshift(next)
      if ((index + 1) % 3 === 0 && formatValue.length > 3 && ((index + 1) < formatValue.length)) {
        prev.unshift(',')
      }
      return prev
    }, [])
    formatNum = `${formatNum.join('')} ${t('vote')}${formatValue <= 1 ? '' : isChina ? 
    '' : 's'}`
    return formatNum
  },
  /**
   * @description: 图片路径调用视频云进行压缩转换
   * @param {String} path 图片Number路径
   * @param {Number} width 图片压缩宽度
   * @return {String} transferPath--转换后路径  path--gif图不进行转换
   */
  formatImg: (path, width, height, cache = true, crop ) => {
    if (!path) return false
    const pathToLowercase = path.toLowerCase();
    // gif及重定向链接不转码
    if (pathToLowercase.includes('gif') || pathToLowercase.includes('/ugc/frontend/attachment/view')) {
      return path;
    }
    let transferPath = `${path}${path.includes('?') ? '&' : '?'}x-ocs-process=image/format,webp`;
    if (width || height) {
      transferPath = `${transferPath}/resize${width ? `,w_${Number(width).toFixed(0)}` : ''}${height ? `,h_${Number(height).toFixed(0)}` : ''}`
    }
    if (crop) {
      transferPath = `${transferPath}/crop,${crop}`
    }
    if (!cache) {
      transferPath = `${transferPath}&t=${uuidv4()}`
    }
    return transferPath;
  },
  // 投票倒计时
  timeCountDown: (leftTime) => {
    // 投票结束
    if (!Number(leftTime)) {
      return t('pollShut')
    } else {
      // 时间四舍五入展示
      const duration = Number(leftTime)
      const leftDay = Math.round(duration / (60 * 60 * 1000 * 24))
      const leftHour = Math.round(duration / (60 * 60 * 1000))
      const leftMinute = Math.round(duration / (60 * 1000))
      if (leftDay >= 1) {
        return `
          ${t('threadPage.polledIn')}
          ${leftDay} 
          ${t('day', leftDay)}
          ${t('left')}
        `
      }
      if (leftHour < 24 && leftHour >= 1 && leftMinute > 60) {
        return `
          ${t('threadPage.polledIn')}
          ${leftHour} 
          ${t('hour', leftHour)}
          ${t('left')}`
      }
      if (leftMinute <= 60) {
        return `
          ${t('threadPage.polledIn')}
          ${leftMinute} 
          ${t('minute', leftMinute)}
          ${t('left')}`
      }
    }
  },
  // 时间格式化 feed流
  timeFormat: (timestamp) => {
    const isChina = import.meta.env.VITE_COUNTRY === 'CHINA'
    const isCH = localStorage.communityLanguage ? JSON.parse(localStorage.communityLanguage).value === 'zh-CN' : false
    const monthList = [
      t('jan'),
      t('feb'),
      t('mar'),
      t('apr'),
      t('may'),
      t('jun'),
      t('jul'),
      t('aug'),
      t('sep'),
      t('oct'),
      t('nov'),
      t('dec'),
    ];
    const time = new Date(Number(timestamp));
    const year = time.getFullYear();
    const month = time.getMonth();
    let date = time.getDate();
    let hours = time.getHours();
    let minutes = time.getMinutes();
    const ctime = new Date(Date.now());
    const cyear = ctime.getFullYear();
  
    date = date < 10 ? `0${date}` : date;
    hours = hours < 10 ? `0${hours}` : hours;
    minutes = minutes < 10 ? `0${minutes}` : minutes;
    const rightNow = ctime.getTime();
    const range = rightNow - timestamp;
    const minute = 60 * 1000;
    const hour = 60 * 1000 * 60;
    if (range < minute) {
      return t('justNow');
    } else if (range >= minute && range < hour) {
      return `
        ${parseInt(range / 1000 / 60)}${isCH ? '' : ' '}${t('min')}${parseInt(range / 1000 / 60) === 1 ? '' : isCH ? '' : 's'
      }${isCH ? '' : ' '}${t('ago')}`;
    } else if (
      year === cyear &&
      time.getDate() === ctime.getDate() &&
      month === ctime.getMonth()
    ) {
      return `${t('today')} ${hours}:${minutes}`;
    } else if (cyear === year) {
      return `${monthList[month]}${
        isChina ? '' : ' '
      }${date}, ${hours}:${minutes}`;
    } else {
      return `${monthList[month]}${
        isChina ? '' : ' '
      }${date}, ${year} ${hours}:${minutes}`;
    }
  },
  /**
 * @description: 时间戳转换日历格式
 * @param {*} timestamp 时间戳
 * @param {*} type  转换类型 0:年月日时分秒，1：年月日，2：月日时分秒，3：时分，4：年月，5：月日时分，6：年月日时分秒，7：月日，8：月日年时分秒，9：月，10：年月日，其他：时分秒
 * @return {*}
 */
  formatTime: (timestamp, type) => {
    if (!Number(timestamp)) return ''
    const isChina = import.meta.env.VITE_COUNTRY === 'CHINA'
    var date = new Date(Number(timestamp)); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-';
    var M =
      (date.getMonth() + 1 < 10
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1) + '-';
    var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    var h =
      (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var m =
      (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
      ':';
    var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    let str = ''
    if (type == 0) {
      return Y + M + D + h + m + s;
    } else if (type == 1) {
      D.trim();
      return Y + M + D;
    } else if (type == 2) {
      return M + D + h + m + s;
    } else if (type == 3) {
      return h + m.split(':')[0];
    } else if (type == 4) {
      return Y.split('-')[0] + '.' + M.split('-')[0];
    } else if (type == 5) {
      return M + D + h + m.split(':')[0];
    } else if (type == 6) {
      return Y + M + D + h + m.split(':')[0];
    } else if (type == 7) {
			str = getMonthEnglish(M)
			return `${str}${isChina ? '' : ' '}${D}`
    } else if (type == 8) {
			str = getMonthEnglish(M)
			return `${str} ${date.getDate()}, ${date.getFullYear()} ${h}${m}${s}`;
    } else if (type == 9) {
      str = getMonthEnglish(M, true)
			return str
    } else if (type == 10) {
      return Y.split('-')[0] + '.' + M.split('-')[0] +'.'+ D.split('-')[0].trim();
    } else if (type === 11) {
      return `${getMonthEnglish(M)} ${D}`;
    } else if (type === 12) {
      str = getMonthEnglish(M)
			return `${str} ${date.getDate()}, ${date.getFullYear()}`;
    } else if (type === 13) {
      str = getMonthEnglish(M)
			return `${str} ${date.getDate()}, ${date.getFullYear()}  ${h}${m.replace(':', '')}`;
    } else {
      return h + m + s;
    }
  },
  // 数值过千转换 feed流
	numFormat: (val = 0) => {
		let num = 0
		if (val < 1000) {
			num = val
		} else if (val === 1000) {
			num = '1,000'
		} else if (val > 1000 && val < 1000000) {
			num = Math.round(val / 100) / 10 + 'k'
		} else if (val === 1000000) {
			num = 1 + 'M'
		} else if (val > 1000000) {
			num = Math.round(val / 100000) / 10 + 'M'
		}
		return num
	},
  existObjKeys: (obj) => {
    return obj && Object.keys(obj).length > 0
  }
}